/**
 * StoresContext
 *
 * React context for accessing multiple named stores from StoresProvider.
 * Contains a record of { store, actions } keyed by store name.
 */

import { createContext } from 'react';
import type { StoresContextValue } from '../Store.types';

export const StoresContext = createContext<StoresContextValue | null>(null);
